import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import { Button, Form, Grid, Header } from 'semantic-ui-react'
import Input from '../../components/Forms/Input'
import ClientsStore from '../../stores/ClientsStore'
import LoadingWrapper from '../../components/LoadingWrapper'
import PropTypes from 'prop-types'

@inject('clientsStore')
@withRouter
@observer
class InspectionsAddressesScreen extends Component {
  static propTypes = {
    clientsStore: PropTypes.instanceOf(ClientsStore),
    match: PropTypes.object,
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.clientId = props.match.params.clientId || null
    this.addressId = props.match.params.addressId || null
    this.isEdit = !!this.addressId
    if (!this.clientId && !this.addressId) {
      props.history.goBack()
    }
  }

  componentDidMount () {
    const { clientsStore } = this.props
    if (this.addressId) {
      clientsStore.loadOneAddress(this.addressId).then(() => {
        this.setState({})
      })
    } else {
      clientsStore.createClientInspectionAddress()
      clientsStore.isLoading = false
    }
  }

  handleSaveAddress = () => {
    const { clientsStore, history } = this.props
    clientsStore.saveInspectionAddress(this.clientId, this.addressId).then((response) => {
      if (response.success) {
        history.push(`/clients/view/${this.clientId}#${response.clientsAddress.id}`)
      }
    })
  }

  render () {
    const { clientsStore } = this.props
    const { isSaving, isLoading } = clientsStore
    if (isLoading) {
      return <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
    }
    return (
      <>
        <LoadingWrapper loading={isSaving} message='Sauvegarde en cours...' />
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Grid columns='equal'>
          <Grid.Row>
            <Grid.Column>
              <Header as='h2'>
                {this.isEdit ? 'Modifier l\'adresse d\'inspection' : 'Ajouter une adresse d\'inspection'}
              </Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Form>
                <Form.Group widths='equal'>
                  <Input
                    name='clientInspectionAddress.route' store={clientsStore}
                    label='Adresse'
                  />
                  <Input name='clientInspectionAddress.room' store={clientsStore} label='Suite' />
                </Form.Group>
                <Form.Group widths='equal'>
                  <Input name='clientInspectionAddress.city' store={clientsStore} label='Ville' />
                  <Input
                    name='clientInspectionAddress.province' store={clientsStore}
                    label='Province'
                  />
                </Form.Group>
                <Form.Group widths='equal'>
                  <Input
                    name='clientInspectionAddress.country' store={clientsStore}
                    label='Pays'
                  />
                  <Input
                    name='clientInspectionAddress.postal_code' store={clientsStore}
                    label='Code postale'
                  />
                </Form.Group>
              </Form>
            </Grid.Column>
          </Grid.Row>
          <Grid.Column>
            <Button
              content='Enregistrer'
              primary
              onClick={this.handleSaveAddress}
            />
          </Grid.Column>
        </Grid>
      </>
    )
  }
}

export default InspectionsAddressesScreen
